import { isMobile } from '../is-mobile';

export const HEADER_CLASSNAME = isMobile()
  ? 'fixed-header--mobile'
  : 'fixed-header';

export const HEADER_GETTER_CLASSNAME =
  process.env.NODE_ENV === 'development'
    ? '.pageHeaderWrapper'
    : 'header.header-rows';

export const getHeader = (): HTMLElement =>
  document.querySelector(HEADER_GETTER_CLASSNAME) as HTMLElement;

type PrevStyle = {
  margin?: string;
  padding?: string;
  paddingBottom?: string;
} | null;

let prevStyles: PrevStyle = null;

const saveCurrentStyles = () => {
  const header = getHeader();
  const parent = header.parentElement;

  const isHasStylesToSaveAndReset =
    parent?.style?.paddingTop ||
    header.style.marginTop ||
    parent?.style?.paddingBottom;

  if (isHasStylesToSaveAndReset && !prevStyles) {
    prevStyles = {
      margin: header.style.marginTop,
      padding: parent?.style.paddingTop,
      paddingBottom: parent?.style.paddingBottom
    };
  }
};

export const getHeaderHeight = (): number => {
  const header = getHeader();

  if (header) {
    return header.clientHeight || header.offsetHeight;
  }

  return 0;
};

export const makeHeaderFixed = (): void => {
  const header = getHeader();

  if (header) {
    if (!header.classList.contains(HEADER_CLASSNAME)) {
      const headerHeight = header.clientHeight || header.offsetHeight;
      saveCurrentStyles();
      header.style.marginTop = `-${headerHeight}px`;

      if (header.parentElement) {
        const paddingTop = window
          .getComputedStyle(header.parentElement, null)
          .getPropertyValue('padding-top');

        const paddingBottom = window
          .getComputedStyle(header.parentElement, null)
          .getPropertyValue('padding-bottom');

        header.parentElement.style.paddingTop = `${
          headerHeight + +paddingTop.replace('px', '')
        }px`;

        header.parentElement.style.paddingBottom = `${
          headerHeight + +paddingBottom.replace('px', '')
        }px`;
      }

      header.classList.add(HEADER_CLASSNAME);
    }
  }
};

export const removeFixedHeader = (): void => {
  const header = getHeader();

  if (header) {
    header.classList.remove(HEADER_CLASSNAME);
    header.style.marginTop = prevStyles?.margin || '';

    if (header.parentElement) {
      header.parentElement.style.paddingTop = prevStyles?.padding || '';
      header.parentElement.style.paddingBottom =
        prevStyles?.paddingBottom || '';
    }
  }

  prevStyles = null;
};
